module.exports = __webpack_public_path__ + "svg/flags/Puerto Rico.svg";